const AUTOMATION_NO_RECORDS_FOUND = 'AUTOMATION_NO_RECORDS_FOUND';
const AUTOMATION_TABLE_HEAD_TITLE = 'AUTOMATION_TABLE_HEAD_TITLE';

export {
  AUTOMATION_NO_RECORDS_FOUND,
  AUTOMATION_TABLE_HEAD_TITLE,
};
